import React, { useState } from "react";
import styled from "styled-components";
import checkout from "../../images/icons/check-out.png";
import { useLocation, useNavigate } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import Loading from "../Loading";

const Container = styled.div`
  width: 100%;
  height: 100%;
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`;

const LogOutForm = styled.div`
  width: 80%;
  max-width: 440px;
  height: 304px;
  border-radius: 10px;
  background: #ffffff;
  color: black;
  padding: 20px;
  position: relative;
`;

const LogOutHeader = styled.div`
  display: flex;
  justify-content: center;
  margin: 20px 0;
`;

const LogOutHeaderImgContainer = styled.div`
  width: 80px;
  height: 80px;
`;

const LogOutHeaderImg = styled.img`
  object-fit: cover;
  width: 100%;
`;

const LogOutText = styled.div`
  font-family: Inter;
  font-size: 20px;
  font-weight: 800;
  line-height: 29px;
  letter-spacing: 0em;
  text-align: center;
  color: #1c1939;
  margin-bottom: 20px;
`;

const LogOutInfo = styled.div`
  font-family: Inter;
  font-size: 14px;
  font-weight: 400;
  line-height: 15px;
  letter-spacing: 0em;
  text-align: center;
  color: #1c1939;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px;
  gap: 50px;
  margin: 30px 0;
`;

const YesButton = styled.button`
  width: 108px;
  height: 38px;
  padding: 10px 16px 10px 16px;
  border-radius: 4px;
  background: #be0303;
  font-family: Poppins;
  font-size: 14px;
  font-weight: 500;
  line-height: 21px;
  text-align: center;
  color: #ffffff;
  border: none;
  cursor: pointer;
  opacity: ${props => props.disabled ? 0.6 : 1};
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};

  &:hover {
    background: ${props => props.disabled ? '#be0303' : '#a00202'};
  }
`;

const NoButton = styled.button`
  width: 108px;
  height: 38px;
  padding: 10px 16px 10px 16px;
  border-radius: 4px;
  background: #ffe9e9;
  font-family: Poppins;
  font-size: 14px;
  font-weight: 500;
  line-height: 21px;
  text-align: center;
  color: #686868;
  border: none;
  cursor: pointer;
  opacity: ${props => props.disabled ? 0.6 : 1};
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
`;

const ModalDrop = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
`;

function LogOutModalMobile({ clickModal }) {
  const axiosPrivate = useAxiosPrivate();
  const location = useLocation();
  const { setAuth, setCloseLogoutFormMobile } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleLogOut = async () => {
    try {
      setLoading(true);
      
      // Call logout API
      await axiosPrivate.post("/gs1/standard/user/logout");
      
      // Clear auth state
      setAuth(null);
      
      // Close modal
      setCloseLogoutFormMobile(false);
      
      // Navigate to login
      navigate("/", { state: { from: location }, replace: true });
    } catch (error) {
      console.error("Logout error:", error);
      
      // Even if logout API fails, clear local auth and redirect
      setAuth(null);
      setCloseLogoutFormMobile(false);
      navigate("/", { state: { from: location }, replace: true });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container>
      <Wrapper>
        <LogOutForm onClick={clickModal}>
          <LogOutHeader>
            <LogOutHeaderImgContainer>
              <LogOutHeaderImg src={checkout} />
            </LogOutHeaderImgContainer>
          </LogOutHeader>
          <LogOutText>Log Out</LogOutText>
          <LogOutInfo>Are you sure you want to Log Out</LogOutInfo>
          <ButtonContainer>
            <YesButton onClick={handleLogOut} disabled={loading}>
              {loading ? "Logging out..." : "Yes"}
            </YesButton>
            <NoButton 
              onClick={() => setCloseLogoutFormMobile(false)}
              disabled={loading}
            >
              Cancel
            </NoButton>
          </ButtonContainer>

          {/* Loading overlay */}
          {loading && (
            <ModalDrop>
              <Loading />
            </ModalDrop>
          )}
        </LogOutForm>
      </Wrapper>
    </Container>
  );
}

export default LogOutModalMobile;